import React, {createRef} from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../../../../../src/core/gd-ui/hint-popover/hint-popover"
import NavigationMenuItemProjectAddMenu from "./add/menu-add"
import NavigationMenuItemProjectMore from '../../../../../src/core/gd-ui/more/project/navigation-project-more-menu'
import MoreProject_PopoverMenu from "../../../../core/gd-ui/more/project/popover-menu"
import NavigationMenuItem_Arrow from "../arrow"
import ProjectSession from "../../../../core/model2/project/project-session"
import NavigationMenuItemProjectRename from "./components/rename-item"
import NavigationMenuItemProject_Icon from "./components/icon";

type Props = {
    style?                  : any

    project                 : ProjectSession
    level                   : number

    dndPreview?             : boolean
    isSelected              : boolean
    isExpanded              : boolean
    colorized?              : boolean
    hideArrow?              : boolean   // used in search to hide expand arrow pass true to hide

    onMenuItemHandleClick?  : func
    onAddInline?            : func
    onRootNodeChange?       : func      // rename swaps the root DOM node - MenuProject_DndItem rebinds to it
}

type State = {
    useHint     : boolean
    hovered     : boolean
    isEditState : boolean
}

// const debug = "NavigationMenuItemProject"
const debug = false

export default class NavigationMenuItemProject extends React.Component<Props, State> {

    private addMenuRef          : any   = createRef()
    private debouncedCheckHint  : any
    private guid                : ID    = gd.utils.guid() // is required for contextMenu because items of one project may be rendered multiple times on screen

    constructor(props: Props) {
        super(props)

        debug && console.log(debug, 'constructor', this.props.project.access, this.props.project.name, this.props.project)

        this.state = {
            useHint     : false,
            hovered     : false,
            isEditState : false,
        };

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300)
    }

    componentDidMount() {
        this.debouncedCheckHint()
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        this.debouncedCheckHint()

        if (prevState.isEditState !== this.state.isEditState) {
            this.props.onRootNodeChange?.()
        }
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel()

        if (gd.layout.contextMenu.isShown && gd.layout.contextMenu.hover?.component?.guid === this.guid) {
            gd.layout.contextMenu.hover.component = null
        }
    }

    showContextMenu = (e: React.MouseEvent) => {
        gd.layout.contextMenu.show(e,
            <MoreProject_PopoverMenu parent         = {this}
                                     project        = {gd.session.projects.get(this.props.project.id)!}
                                     hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component   : this,
                className   : 'hovered'
            }
        )
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.project.name, findDOMNode(this), 75, 14)
        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    // is for ReorderItem to disable DND while rename is active
    get canDrag() {
        return !this.state.isEditState
    }

    onMenuItemHandleClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if(this.props.onMenuItemHandleClick){
            this.props.onMenuItemHandleClick(this.props.project.id, e)
        }

    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        const noAccess : boolean = !this.props.project.hasAccess


        // !this.props.project.isArchived - added because it kills archived projects click in pins
        // because arhcived projects never have users = no access
        if (noAccess && !this.props.project.isArchived) {

            if (this.props.project.treeChildren) {
                this.onMenuItemHandleClick(e)
            }

            return
        }

        const project : ProjectSession  = gd.session.projects.get(this.props.project.id)!

        // libo group libo custom settings dlya folder
        if (project.isCategory || project.properties.treatAsCatalog) {
            if (this.props.project.treeChildren) {
                this.onMenuItemHandleClick(e)
            } else {
                this.addMenuRef.current?.showPopover(e)
            }
            return
        }

        // // custom settings for folders & projects
        // if (project.properties.handleExpandInsteadOfOpen) {
        //
        //     if (this.props.project.treeChildren) {
        //         this.onMenuItemHandleClick(e)
        //     } else {
        //         project.goTo()
        //     }
        // }

        project.goTo()
    }

    onRename = () => {
        this.setState({
            isEditState: !this.state.isEditState
        })
    }

    render() {
        debug && console.log(debug, 'render', this.props.project.id, this.props.project)

        if (!this.props.project) {
            console.error("ERROR #kdjdjh24 - how come no project found - onProjectDelete ?")
            return null
        }

        debug && console.log(debug, 'render', this.props.project.id)

        const contextMenuIsShown = gd.layout.contextMenu.isShown && gd.layout.contextMenu.hover?.component?.guid === this.guid
        if (contextMenuIsShown) {
            gd.layout.contextMenu.hover!.component = this
        }

        if (this.state.isEditState) {
            return (
                <NavigationMenuItemProjectRename project    = {this.props.project}
                                                 level      = {this.props.level}
                                                 onDone     = {this.onRename}/>
            )
        }

        const noAccess : boolean        = !this.props.project.access
        const showAdd : boolean         = !!this.props.onAddInline && !gd.user.acl.isClient && !!this.props.project?.properties.canCreate
        const isHovered : boolean       = this.state.hovered || contextMenuIsShown
        const hasNotArchivedChildren    = this.props.project.treeHasNotArchivedChildren
        const isArrowHidden : boolean   = !hasNotArchivedChildren || !!this.props.hideArrow


        // there should not be any project without access (is there any real case?)
        if (noAccess) {
            console.warn('NavigationMenuItemProject render: project without access', this.props.project)
        }

        const classes = Classes('item project', 'level-'+this.props.level, 'projectId-'+this.props.project.id /*required for scroll to node*/, {
            'selected'      : this.props.isSelected,
            'dnd-preview'   : this.props.dndPreview,
            'hovered'       : isHovered,
        })

        // style is required for ReorderList (pointer-events: none)
        return (
            <div className={classes} style={this.props.style} onClick={this.onClick} onContextMenu={this.showContextMenu}>

                <div className="row">
                    <NavigationMenuItem_Arrow isHidden   = {isArrowHidden}
                                              isExpanded = {this.props.isExpanded}
                                              onClick    = {this.onMenuItemHandleClick}/>

                    <NavigationMenuItemProject_Icon {...this.props} />

                    <div className="name">{this.props.project.name}</div>


                    {!noAccess &&
                        <div className="controls">

                            {!gd.user.acl.isClient &&
                                <NavigationMenuItemProjectMore projectId    = {this.props.project.id}
                                                               parent       = {this}
                                                               showPinStar  = {true}/>}

                            {showAdd &&
                                <NavigationMenuItemProjectAddMenu ref           = {this.addMenuRef}
                                                                  className     = ""
                                                                  projectId     = {this.props.project.id}
                                                                  parent        = {this}
                                                                  onAddInline   = {this.props.onAddInline}/>}

                        </div>
                    }


                    {!noAccess &&
                        <>
                            {/*{!gd.user.acl.isClient &&*/}
                            {/*    <NavigationMenuItemProjectMore projectId    = {this.props.project.id}*/}
                            {/*                                   parent       = {this}*/}
                            {/*                                   showPinStar  = {true}/>}*/}

                            {/*{showAdd &&*/}
                            {/*    <NavigationMenuItemProjectAddMenu ref           = {this.addMenuRef}*/}
                            {/*                                      projectId     = {this.props.project.id}*/}
                            {/*                                      parent        = {this}*/}
                            {/*                                      onAddInline   = {this.props.onAddInline}/>}*/}

                        </>}
                </div>

                {this.state.useHint &&
                    <HintPopover hint       = {this.props.project.name}
                                 multiline  = {true}/>
                }
            </div>
        )
    }
}
